import {
  cn,
  IconButtonAsButton,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@newfront-insurance/core-ui/v2';

import { useChatOverlayContext } from '../../contexts/chat-overlay-context';
import { IconFullscreen, IconMinimize } from '../icons';

interface ChatHeaderActionsProps {
  className?: string;
}

/**
 * Header actions component for fullscreen toggle and close button.
 * Uses context to access state and handlers.
 */
export function ChatHeaderActions({ className }: ChatHeaderActionsProps) {
  const { isStandaloneMode, isFullscreen, setIsFullscreen, onClose } = useChatOverlayContext();

  if (isStandaloneMode) {
    return null;
  }

  return (
    <TooltipProvider>
      <div className={cn('flex items-center gap-2', className)}>
        <Tooltip>
          <TooltipTrigger>
            <IconButtonAsButton onClick={() => setIsFullscreen(!isFullscreen)}>
              <IconFullscreen />
            </IconButtonAsButton>
          </TooltipTrigger>
          <TooltipContent>Toggle Fullscreen</TooltipContent>
        </Tooltip>
        <Tooltip>
          <TooltipTrigger>
            <IconButtonAsButton onClick={onClose}>
              <IconMinimize />
            </IconButtonAsButton>
          </TooltipTrigger>
          <TooltipContent>Minimize</TooltipContent>
        </Tooltip>
      </div>
    </TooltipProvider>
  );
}
